import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ViewMode } from '../../types/api';
import {
  generateEPubDownloadURL,
  generatePDFDownloadURL,
  generateRSSDownloadURL,
} from '../../services/downloads';
import { useCurrentUser } from '@/services/userHooks';

interface DownloadOptionsProps {
  mode?: ViewMode;
  folderId?: string;
  tagSlug?: string;
  closePopover?: () => void;
}

function DownloadOptions({
  mode = 'home',
  folderId,
  tagSlug,
  closePopover,
}: DownloadOptionsProps) {
  const { currentUser } = useCurrentUser();
  const epubURL = generateEPubDownloadURL(mode, folderId, tagSlug);
  const pdfURL = generatePDFDownloadURL(mode, folderId, tagSlug);
  const rssURL = generateRSSDownloadURL(mode, currentUser, folderId, tagSlug);

  const handleDownload = (
    e: React.MouseEvent,
    downloadURL: string,
    openInNewWindow: boolean = false,
  ) => {
    e.preventDefault();
    if (openInNewWindow) {
      window.open(downloadURL, '_blank');
    } else {
      window.location.href = downloadURL;
    }
    closePopover?.();
  };

  return (
    <>
      {/* Download Heading */}
      <div className="menu-header">
        <Trans>Download</Trans>
      </div>

      {/* Download Options */}
      <div className="flex flex-col">
        {epubURL && (
          <button onClick={(e) => handleDownload(e, epubURL)} className="menu-item">
            <span>ePub</span>
          </button>
        )}
        {pdfURL && (
          <button onClick={(e) => handleDownload(e, pdfURL)} className="menu-item">
            <span>PDF</span>
          </button>
        )}
        {rssURL && (
          <button onClick={(e) => handleDownload(e, rssURL, true)} className="menu-item">
            <span>RSS</span>
          </button>
        )}
      </div>
    </>
  );
}

export default DownloadOptions;
